export const DISABLED_TOOL_GROUPS = ['toolbarGroup-Edit', 'toolbarGroup-Forms', 'toolbarGroup-EditText'];
export const DISABLED_TOOLS_KEYWORDS = ['Content', 'AddParagraphTool', 'FormField', 'Crop'];

export const SYNC_MODES = {
  'SYNC': 'SYNC',
  'SKIP_UNMATCHED': 'SKIP_UNMATCHED',
};
